<template>
  <DragDialog
  class="custom-drag-dialog-primary"
    title="提示"
    :width="600"
    size="18"
    icon="el-icon-warning"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
  >
    <div class="exception-box custom-drag-dialog-primary-body">
      <div class="error-tip-box">
        <!-- <div class="icon-box">
          <i class="el-icon-warning"></i>
        </div> -->
        <div class="msg-box error-tips">
          {{ errMsg }}
        </div>
      </div>
      <div class="details-box" v-if="isDetailsVisible()">
        <div class="collapse-box" @click="toggleDetailVisible">
          <icon-svg icon-class="ic-chakanxiangqing" class="icon" />
          <span>查看详情</span>
          <i
            :class="`el-icon-caret-bottom collapse-icon ${
              isDetailVisible ? 'rotate' : ''
            }`"
          />
        </div>
        <div
          class="exist-file-box"
          v-if="errType.includes('existException') && isDetailVisible"
        >
          <div>已存在文件：</div>
          <div class="data-content-box">
            <div
              v-for="(item, index) in existFiles"
              :key="index"
              class="item-box"
            >
              {{
                `${existFiles.length > 1 ? `${index + 1}. ` : ""}${
                  item.fileName
                }`
              }}
            </div>
          </div>
        </div>
        <div
          class="exist-file-box"
          v-if="errType.includes('existAndQuoteException') && isDetailVisible"
        >
          <div>已存在文件：</div>
          <div class="data-content-box">
            <div
              v-for="(item, index) in existFiles"
              :key="index"
              class="item-box"
            >
              {{
                `${existFiles.length > 1 ? `${index + 1}. ` : ""}${
                  item.fileName
                }`
              }}
            </div>
          </div>
        </div>
        <div
          class="scene-box"
          v-if="errType.includes('QuoteException') && isDetailVisible"
        >
          <div>被引用的数据集与对应场景：</div>
          <div class="data-content-box">
            <div class="common-tree-box" v-if="isTreeVisible">
              <el-tree
              class="tree-primary"
                :data="treeData"
                :indent="20"
                default-expand-all
                :expand-on-click-node="false"
              />
            </div>
            <div v-else class="scene-list">
              <div
                v-for="(item, index) in sceneList"
                :key="index"
                class="item-box"
              >
                {{
                  `${sceneList.length > 1 ? `${index + 1}. ` : ""}${
                    item.sceneName
                  }`
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="common-button-box custom-drag-dialog-primary-footer">
      <el-button
        size="small"
        class="hollowOut-btn primary-ang-btn gr8"
        @click="cancel"
        v-if="
          !errType.includes('extNameException') &&
          !errType.includes('updateFileExistException') &&
          !errType.includes('convertingException')
        "
        >取消</el-button
      >
      <el-button class="primary-btn primary-ang-btn" size="small" type="primary" @click="continueUpload">
        确定
      </el-button>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";

export default {
  data() {
    return {
      visible: false,
      eventSource: "",
      errType: "",
      errMsg: "",
      isDetailVisible: false,
      isTreeVisible: false,
      treeData: [],
      sceneList: [],
      existFiles: [],
      convertingFiles: [],
    };
  },
  props: {
    customUploader: Object,
  },
  components: {
    DragDialog,
  },
  mounted() {
    if (this.customUploader) {
      this.customUploader.on("fileException", this.onFileException);
    }

    this.$eventManage.on("fileException", this.onFileException);
  },
  beforeDestroy() {
    if (this.customUploader) {
      this.customUploader.off("fileException", this.onFileException);
    }

    this.$eventManage.off("fileException", this.onFileException);
  },
  methods: {
    onFileException(events) {
      let eventInfo = events.eventInfo;
      this.visible = true;
      this.errType = eventInfo.errType;
      this.errMsg = eventInfo.errMsg;
      this.eventSource = eventInfo.eventSource;

      this.handleExceptionData(eventInfo);
    },
    handleExceptionData(eventInfo) {
      let errType = eventInfo.errType;
      if (errType === "existException") {
        let existFiles = eventInfo.existFiles;
        this.existFiles = existFiles;
      }
      if (errType === "sceneQuoteException") {
        let quoteData = eventInfo.quoteData;
        if (quoteData.length > 1) {
          this.isTreeVisible = true;
          let treeData = [];
          quoteData.forEach((item) => {
            let children = item.refScenes.map((el) => {
              return { nodeId: el.sceneId, label: el.sceneName, children: [] };
            });
            let obj = {
              nodeId: item.dataSetId,
              label: item.dataSetName,
              children,
            };
            treeData.push(obj);
          });
          this.treeData = treeData;
        } else {
          let dataSetInfo = quoteData[0];
          if (dataSetInfo.refScenes) {
            let sceneList = dataSetInfo.refScenes;
            this.sceneList = sceneList;
          } else {
            let sceneList = quoteData;
            this.sceneList = sceneList;
          }
        }
      }
      if (errType === "existAndQuoteException") {
        this.isTreeVisible = true;

        let quoteData = eventInfo.quoteData;
        let treeData = [];
        quoteData.forEach((item) => {
          let children = item.refScenes.map((el) => {
            return { nodeId: el.sceneId, label: el.sceneName, children: [] };
          });
          let obj = {
            nodeId: item.dataSetId,
            label: item.dataSetName,
            children,
          };
          treeData.push(obj);
        });
        this.treeData = treeData;

        let existFiles = eventInfo.existFiles;
        this.existFiles = existFiles;
      }
      if (errType === "convertingException") {
        let existFiles = eventInfo.convertingFiles;
        this.convertingFiles = existFiles;
      }
    },
    toggleDetailVisible() {
      this.isDetailVisible = !this.isDetailVisible;
    },
    cancel() {
      let obj = {
        eventSource: this.eventSource,
        errType: this.errType,
        order: "cancel",
      };
      if (this.eventSource === "uploader") {
        this.customUploader.fire("handleFileException", { eventInfo: obj });
      } else {
        this.$eventManage.fire("handleFileException", { eventInfo: obj });
      }

      this.closeDialog();
    },
    continueUpload() {
      if (
        this.errType === "extNameException" ||
        this.errType === "updateFileExistException"
      ) {
        this.cancel();
      } else {
        let obj = {
          eventSource: this.eventSource,
          errType: this.errType,
          order: "continue",
        };
        if (this.eventSource === "uploader") {
          this.customUploader.fire("handleFileException", { eventInfo: obj });
        } else {
          this.$eventManage.fire("handleFileException", { eventInfo: obj });
        }

        this.closeDialog();
      }
    },
    closeDialog() {
      this.eventSource = "";
      this.errType = "";
      this.errMsg = "";
      this.isDetailVisible = false;
      this.isTreeVisible = false;
      this.treeData = [];
      this.sceneList = [];

      this.visible = false;
    },
    isDetailsVisible() {
      let visible = false;
      let errType = this.errType;
      if (errType.includes("QuoteException")) {
        visible = true;
      } else if (errType.includes("existException")) {
        if (this.existFiles.length > 1) {
          visible = true;
        }
      }
      return visible;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.exception-box {
  color: var(--default-color);

  .error-tip-box {
    display: flex;
    .icon-box {
      color: #ec9d00;
      font-size: 18px;
      margin-right: 5px;
    }

    .msg-box {
      margin-left: 5px;
      word-break: break-all;
      overflow: hidden;
    }
  }

  .details-box {
    margin-top: 10px;

    .collapse-box {
      display: flex;
      align-items: baseline;
      margin: 10px 0px;
      user-select: none;
      display: flex;
      align-items: center;

      .icon {
        margin-right: 5px;
      }

      .collapse-icon {
        margin-left: 5px;
        cursor: pointer;
      }

      .rotate {
        transform: rotate(-180deg);
      }
    }

    .exist-file-box {
      .data-content-box {
        display: block;
        max-height: 200px;
        margin: 10px 0px;
        padding: 15px;
        overflow-y: auto;
        background: #2c2c2c;

        .item-box {
          margin: 5px 0px;
        }
      }
    }

    .scene-box {
      .data-content-box {
        padding: 15px;
        max-height: 200px;
        overflow-y: auto;

        .common-tree-box {
          width: 100%;
          max-height: 300px;
          overflow-y: auto;
        }

        .scene-list {
          .item-box {
            margin: 5px 0px;
          }
        }
      }
    }
  }
}

.common-button-box {
  text-align: right;
}
</style>